<!--<ul class="layout-menu" style="background-color:white !important; min-width:300px; padding:10px 10px 10px 10px">-->



<div class="pl-2 pt-3 pb-0">
    <ng-container *ngIf="!isArchiveInstance" style="padding-top:12px !important;">
        <strong class="ml-2" style="color:black">Last Sync:</strong><span class="ml-1" style="color:black"> {{(applicationPreferences | async)?.lastSyncTime | date : 'MM/dd/yy, h:mm a'}}</span>
    </ng-container>

</div>
<ul class="layout-menu mt-2" style="background-color: white !important">
    <ng-container *ngFor="let item of model; let i = index">
        <ng-container *ngIf="item.visible">
            <li app-menuitem
                [item]="item"
                [index]="i"
                [root]="true"
                [visible]="item.visible"
                style="
          background-color: #ffffff !important;
          min-width: 300px;
          max-width: 600px;
          padding: 0px 10px 10px 0px !important;
        "
                class="p-ripple p-element cursor-pointer select-none p-3 transition-duration-150 border-round flex align-items-center justify-content-center md:justify-content-start md:flex-1 flex-auto ng-star-inserted bg-primary"></li>
        </ng-container>
    </ng-container>
</ul>
